__turbopack_context__.v({
  "multi_livestream__schedule__timeline": "Frh7EG_multi_livestream__schedule__timeline",
  "time_indicator": "Frh7EG_time_indicator",
  "time_slot": "Frh7EG_time_slot",
  "time_slot__day": "Frh7EG_time_slot__day",
});
